/**
 * What shows while a lazily-loaded route chunk is in flight.
 *
 * Deliberately NOT a full-page spinner. Before route-level code splitting
 * every navigation was instant, so a centred spinner would read as a new
 * loading state the app never used to have — and on a warm cache the chunk
 * arrives in single-digit milliseconds, which would make it a flash rather
 * than feedback.
 *
 * Instead: a 2px indeterminate bar pinned to the top. No layout shift, no
 * flash on a fast load, and honest feedback on a slow one — which is exactly
 * the case this exists for, a sole trader on two bars in a paddock.
 *
 * `aria-busy` + a polite live region so a screen reader is told the page is
 * loading rather than being handed a silently empty document.
 */

export function RouteFallback() {
  return (
    <div role="status" aria-busy="true" aria-live="polite" className="fixed inset-x-0 top-0 z-[9999]">
      <div className="h-0.5 w-full overflow-hidden bg-brand-secondary/15">
        <div className="h-full w-1/3 animate-route-progress rounded-full bg-brand-secondary" />
      </div>
      <span className="sr-only">Loading…</span>
    </div>
  );
}
